import type { ConfigOptions, MeasurementConfig } from '@cloudflare/speedtest';
import { DOWNLOAD_PATH, UPLOAD_PATH } from '../shared/limits';

// Trimmed from the engine's 25-step default. Each bandwidth type stops early once every request in a
// round takes longer than bandwidthFinishRequestDuration, so slower links end on smaller payloads.
export const SPIKE_MEASUREMENTS: MeasurementConfig[] = [
  { type: 'latency', numPackets: 1 },
  { type: 'download', bytes: 1e5, count: 1, bypassMinDuration: true },
  { type: 'latency', numPackets: 20 },
  { type: 'download', bytes: 1e5, count: 3 },
  { type: 'download', bytes: 1e6, count: 3 },
  { type: 'download', bytes: 4e6, count: 2 },
  { type: 'download', bytes: 1e7, count: 2 },
  { type: 'download', bytes: 25e6, count: 2 },
  { type: 'download', bytes: 5e7, count: 2 },
  { type: 'download', bytes: 1e8, count: 2 },
  { type: 'upload', bytes: 1e5, count: 3 },
  { type: 'upload', bytes: 1e6, count: 3 },
  { type: 'upload', bytes: 4e6, count: 2 },
  { type: 'upload', bytes: 1e7, count: 2 },
  { type: 'upload', bytes: 25e6, count: 2 },
  { type: 'upload', bytes: 5e7, count: 2 },
];

export const SPIKE_ENGINE_CONFIG = {
  autoStart: false,
  downloadApiUrl: DOWNLOAD_PATH,
  uploadApiUrl: UPLOAD_PATH,
  // null disables the engine's result reporting to speed.cloudflare.com (__results) and per-request logging.
  logAimApiUrl: null,
  logMeasurementApiUrl: null,
  measurements: SPIKE_MEASUREMENTS,
  measureDownloadLoadedLatency: true,
  measureUploadLoadedLatency: true,
  bandwidthFinishRequestDuration: 1000,
  loadedLatencyThrottle: 400,
  loadedRequestMinDuration: 250,
  latencyPercentile: 0.5,
  bandwidthPercentile: 0.9,
} satisfies ConfigOptions;
